
























import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {uuid} from 'vue-uuid'
import {namespace} from 'vuex-class';
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';

const auth = namespace('auth')

@Component({
  name: 'DataScanFromProduct',
  components: {ChangeClicker}
})
export default class DataScanFromProduct extends Vue {
  typeDiagram = 'bar'
  changeTypeDiagramm(type:string) {
    this.chartOptions.chart.type = type
    this.chartOptions.series[0].data = this.items
    this.chartOptions.chart.height =  type === 'bar' &&  this.items.length>20? this.items.length * 25 : 505
    this.chartOptions.chart.marginBottom =  type === 'bar' || type === 'pie' ? '50' : '200'
    this.chartOptions.xAxis.labels.rotation =  type === 'bar' ? 0 : -70
  }

  @Prop({type: Array || null, default: []}) items!: string[]
  @Prop({type: String, default: ''}) title!: string
  product:any[] = []

  @Watch('items',{immediate: true, deep: true})
  getItems(NewVal: any) {
    this.chartOptions.series[0].data = NewVal
    this.chartOptions.chart.type = this.typeDiagram
  }

  chartOptions = {
    chart: {
      style: {"fontSize": "12px"},
      height: 505,
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '20',
      marginBottom: '50',
      type: this.typeDiagram,
    },
    colors: ['#3290ED', '#F04864', '#FACC14', '#2FC25B', '#13C2C2',
      '#ED7532', '#DE32ED', '#18AC2F', '#7BC9F5', '#70179A'],
    title: {
      text: ''
    },
    subtitle: {},
    credits: {
      enabled: false
    },
    xAxis: {
      allowDecimals: false,
      type: 'category',
      labels: {
        rotation: 0,
        style: {
          fontSize: '12',
          fontFamily: 'Verdana, sans-serif'
        }
      }
    },
    yAxis: {
      allowDecimals: false,
      title: {
        text: this.$t('newstatistics.general.scans')
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        colorByPoint: true,
      },
      bar: {
        colorByPoint: true
      },
      pie: {
        chart: {
          marginLeft: 0,
          marginBottom: '10',
          height: '505'
        },
        legend: {
          enabled: false,
          align: 'left',
          verticalAlign: 'top',
          layout: 'vertical',
          x: 0,
          y: 100
        },
        cursor: 'pointer',
        dataLabels: {
          alignTo: 'plotEdges',
          style: {
            color:'black',
            shadow:false,
            textOverflow: 'clip'
          }
        },
        showInLegend: false,
        startAngle: -180,
        endAngle: 180,
        center: ['50%', '50%'],
        size: '90%'
      },
      line: {

      },
      series: {
        stacking: 'normal'
      },
    },
    series: [{
      innerSize: '50%',
      name: this.$t('newstatistics.general.scans'),
      data:this.items
    }]
  }

}
